import ExperienceWrapper from 'components/experience-wrapper';
import config from 'config';
import { IEntry } from 'global';
import React, { useMemo } from 'react';
import { omitNullableHandler } from 'utils/type-helper';
import { capitalize } from '../../../../utils/strings';
import Sections from '../../sections';
import { useContentful } from '../context';

const ContentCmsContentStatic: React.FC = () => {
  const { nodeEnv } = config;
  const { data: contentful } = useContentful();

  const sections: Array<IEntry> = useMemo(() => {
    return (
      (contentful.fields.sections as Array<IEntry>)?.filter(
        omitNullableHandler
      ) || []
    );
  }, [contentful]);
  return (
    <>
      {sections.map((section, index) => {
        // This entry is either
        // - deleted
        // - archived
        // - unpublished
        if (!section.sys.contentType) {
          return '';
        }

        if (
          'productInformationTab' in section.fields &&
          section.fields.productInformationTab
        )
          return '';

        const componentIdentifier = capitalize(section.sys.contentType.sys.id);

        if (typeof Sections[componentIdentifier] === 'undefined') {
          if (nodeEnv === 'development') {
            return (
              <div
                key={index}
                className="bg-red-500 p-5 text-center font-black text-text-dark-bg-contrast-white"
              >
                Template missing for {componentIdentifier}
              </div>
            );
          }

          console.warn(
            'Missing template for contentful section',
            componentIdentifier
          );
          return '';
        }

        const Component = Sections[componentIdentifier];

        if (typeof section.fields['nt_experiences'] !== 'undefined') {
          return (
            <ExperienceWrapper
              component={Component}
              key={section.sys.id}
              entry={section}
            />
          );
        } else {
          return (
            <Component
              key={section.sys.id}
              id={section.sys.id}
              {...(section.fields as any)}
            />
          );
        }
      })}
    </>
  );
};

export default ContentCmsContentStatic;
